/* @flow */

import { pressDuration } from '@e180/ui/lib/token/animation';
import { minTargetSize } from 'src/shared/app/base/style/token/box';

export default {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: minTargetSize,
    height: minTargetSize,

    transformOrigin: 'center center',
    transition: `transform ${pressDuration}`,

    '&:hover': {
      transform: 'scale(1.1, 1.1)',
    },

    '&:active': {
      transform: 'scale(0.9, 0.9)',
    },
  },
  'root-isTrimmed': {
    width: 'auto',
    height: 'auto',
  },
};
